module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CPvMaW/tc-custom/9781439664551.jpg?1705026122760",
      "alt": "This image is the cover for the book Grand Rapids and the Civil War, Civil War Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Grand Rapids and the Civil War, Civil War Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Grand Rapids responded to President Abraham Lincoln's call for troops with passionate swiftness. Kent County men fought stubbornly on memorable battlefields like First Bull Run, Stones River and Gettysburg, as well as obscure places like Boonville, La Vergne and Mossy Creek. An affinity for cavalry earned Grand Rapids the moniker \"Michigan's Horse Soldier City,\" while Valley City engineers designed and constructed spectacular railroad bridges throughout the South. Back home, the soldiers' mothers, wives and sisters faced the conflict's many challenges with patriotic doggedness. Dr. Roger L. Rosentreter chronicles how Grand Rapids citizens responded to wartime trials and tribulations while helping the North save the Union and end slavery.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Roger L. Rosentreter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("A native Michiganian, Roger L. Rosentreter is an assistant professor in the Department of History at Michigan State University. He also served as editor of Michigan History Magazine from 1988 through 2009. He has written and published extensively on Michigan's past, including his most recent book, Michigan: A History of Explorers, Entrepreneurs & Everyday People, published by the University of Michigan Press. Rosentreter has given numerous presentations on Michigan history, with a special focus on the state's role in the Civil War.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0